// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1ZToR","list":"styles_list__1QcYp"};